export default {"src":"/_next/static/media/inner-3.4b9fceeb.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};